// removed by extract-text-webpack-plugin
module.exports = {"tagWrapper":"index__tagWrapper___26U60","tagGroup":"index__tagGroup___1LZ9h","tagContent":"index__tagContent___3kRi-","sorter-modal-title":"index__sorter-modal-title___6yw0q","filter-modal-cusbtn":"index__filter-modal-cusbtn___1Beq2","iconOrder":"index__iconOrder___tJSAK","ascending":"index__ascending___2o8hc"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ReportTableSetup/index.less
// module id = 329
// module chunks = 3